'use client';

import { usePathname, useSearchParams } from 'next/navigation';
// @ts-ignore
import nprogress from 'nprogress/nprogress.js';
import { useEffect } from 'react';

import 'nprogress/nprogress.css';

export function NavigationEvents() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    nprogress.configure({
      parent: 'body',
      easing: 'ease-in-out',
      speed: 400,
    });

    return () => {
      nprogress.remove();
    };
  }, []);

  useEffect(() => {
    nprogress.start();

    const interval = setInterval(() => {
      nprogress.inc(0.3 * Math.cos(nprogress.status * (Math.PI / 2)));
    }, 150);

    const url = `${pathname}?${searchParams}`;

    if (url) {
      nprogress.done();
      clearInterval(interval);
    }
  }, [pathname, searchParams]);

  return null;
}
